<template>
    <header>
        <Sousuo :searchActive.sync="searchActive"></Sousuo>

        <div class="header">
            <div class="inner">
                <div class="logo">
                    <a href="../../../public/index.html">
                        <img class="ffff" src="../../assets/LOGO.png" alt="" />
                    </a>
                </div>

                <div class="mm">
                    <el-button  class="search"  @click="drawer = true"
                               type="primary" >
                        <img  src="../../assets/搜索.png" />
                    </el-button>

                    <el-drawer
                            size="85%"
                            :modal="false"
                            :visible.sync="drawer"
                            :direction="direction"
                            :before-close="handleClose">
                        <div   class="tab">
                            <li class="active">
                                <a class="p-a" href="#/login">首页</a>
                                <div class="xx"></div>
                            </li>

                            <li>
                                <router-link
                                        :to="{ path: '/zou/a', query: { id: 'a' } }"
                                        class="p-a"
                                        :class="{
                                active:
                                active == 'a'
                                ||active == 'b'
                                ||active == 'g'
                                ||active == 'c'
                                ||active == 'e'
                                 ||active == 'f'
                                  ||active == 'meng'

                            }"
                                >
                                    走进大伟嘉
                                </router-link>
                                <div class="xx"></div>
                                <div class="sub">
                                    <div class="s-i">
                                    </div>
                                </div>
                            </li>
                            <li>
                                <router-link
                                        class="p-a"
                                        :to="{ path: '/xin', query: { id: 'xin' } }"
                                        :class="{
                                active:active == 'xin'
                                ,
                            }"

                                >新闻资讯</router-link
                                >
                                <div class="xx"></div>
                                <div class="sub">
                                    <div class="s-i">
                                    </div>
                                </div>
                            </li>
                            <li>
                                <router-link
                                        :to="{ path: '/chan', query: { id: 'first' } }"
                                        class="p-a"
                                        :class="{
                                active:
                                active == 'first'
                                ||active == 'second'
                                ||active == 'third'
                                ||active == 'fourth'
                                ||active == 'fifth'
                                ,
                            }"
                                >产业布局</router-link
                                >
                                <div class="xx"></div>
                                <div class="sub">
                                    <div class="s-i">
                                    </div>
                                </div>
                            </li>
                            <li>
                                <router-link
                                        :to="{ path: '/ke/left', query: { id: 'left' } }"
                                        class="p-a"
                                        :class="{ active: active == 'left'||active == 'center'||active == 'right' }"
                                        @click="active = 'left'"
                                >科研创新</router-link
                                >
                                <div class="xx"></div>
                                <div class="sub">
                                    <div class="s-i">
                                    </div>
                                </div>
                            </li>
                            <li>
                                <router-link
                                        :to="{ path: '/ren', query: { id: 'ren' } }"
                                        class="p-a"
                                        href="#/ren"
                                        :class="{ active: active == 'ren' }"
                                        @click="active = 'ren'"
                                >人才中心</router-link
                                >
                                <div class="xx"></div>
                            </li>
                            <li>
                                <router-link
                                        :to="{ path: '/she', query: { id: 'she' } }"
                                        class="p-a"
                                        href="#/she"
                                        :class="{ active: active == 'she' }"
                                        @click="active = 'she'"
                                >社会责任</router-link
                                >
                                <div class="xx"></div>
                            </li>

                            <li>
                                <router-link
                                        :to="{ path: '/lian', query: { id: 'lian' } }"
                                        class="p-a"
                                        href="#/lian"
                                        :class="{ active: active == 'lian' }"
                                        @click="active = 'lian'"
                                >联系我们</router-link
                                >
                            </li>
                        </div>
                    </el-drawer>

                </div>
            </div>
        </div>
    </header>
</template>

<script>
  import { getAboutList, getNewsCategoty } from "../../api/index";
  import Sousuo from "../../components/common/Sousuo";
  export default {
    name: "Top",
    components: { Sousuo },
    data() {
      return {
        drawer: false,
        direction: 'ttb',
        data: [],
        dat: [],
        searchActive: "",
      };
    },
    methods: {
      handleClose(done) {
              done();
      }
    ,
      updateId(i) {
        this.$bus.$emit("updateId", i);
      },
    },
    mounted() {
      getAboutList().then((res) => {
        // console.log(res.data);
        let data = res.data;
        this.data = data;
      }),
          getNewsCategoty().then((resa) => {
            let dat = resa.data;
            this.dat = dat;
          });
    },
  };
</script>

<style lang="less">
    .xx{
        width: 90vw;
        height: 0.1vh;
        background-color: #E2E2E2;
        margin-top: 3vh;
        margin-left: 5vw;
    }
    a:hover {
        color: #d3001c;
    }
    header {
        position: relative;
        display: block;
        .header {
            background-color: white;
            position: relative;
            height: 7vh;
            .inner {
                width: 100%;
                margin: 0 auto;
                display: flex;
            }
                .logo {
                    width: 30%;
                    display: flex;
                    align-items: center;
                    .ffff {
                        height: 4.5vh !important;
                        margin-bottom: 0 !important;
                        margin-top: 0 !important;
                        margin-left: 5vw;
                    }
                }

            .tab {
                .p-a {
                    font-family: PingFang SC, PingFang SC-Regular;
                    padding: 0 0;
                    align-items: center;
                    justify-content: center;
                    border-bottom: 0.2809vh solid transparent;
                    color: #000000;
                    font-size: 4.17vw;
                }
                li {
                    margin-bottom: 3vh;
                    text-align: center;
                    &.active,
                    &:hover {
                        .p-a {
                            color: red;
                        }
                    }
                }
            }
            .mm{
                width: 70%;
            }
            .search {
                width: 20%;
                margin-left: 80%;
                height: 7vh;
                background-color: #d7000f;
                border-color: #d7000f!important;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                img {
                    width: 100%;
                }
            }
        }
    }
    .el-icon-close:before{
        background-color: #d7000f!important;
        padding: 6vw;
        padding-top: 8vw;
        color: white;
        margin-left: 5vw;
        width: 20vw;
    }
    .el-drawer__header{
        padding: 30px 0 !important;
        background-image: url('../../assets/7.jpg') ;
        background-repeat: no-repeat;
        background-size: 40% ;
        margin-left: 8%;
    }
    .el-button{
        border-radius: 0;
    }

</style>
